<div class="bg-white p-4 my-card">
  <nz-row [nzGutter]="[24, 16]">
    <nz-col
      [nzLg]="{ span: 12, offset: 0 }"
      [nzMd]="{ span: 24, offset: 0 }"
      [nzSm]="{ span: 24, offset: 0 }"
      [nzXs]="{ span: 24, offset: 0 }">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="primary-color mb-0">Come sta andando?</h4>

        <ng-container *ngIf="!isEdit">
          <button
            *ngIf="isLoggedUser && !userReveal"
            [disabled]="!existHowIsGoing"
            (click)="setReveal()"
            nz-button
            [ngClass]="
              !existHowIsGoing ? 'disabled-btn' : 'primary-btn cursor-pointer'
            ">
            Rivela
          </button>
          <div class="reveal-badge" *ngIf="isLoggedUser && userReveal">
            <p class="mb-0">Rivelato</p>
          </div>
        </ng-container>
      </div>

      <nz-row
        *ngIf="!isEdit"
        class="tiny-card px-2"
        [ngClass]="
          !isLoggedUser && !userReveal && !reviewerReveal ? 'blurred' : ''
        ">
        <nz-col
          [nzLg]="{ span: 24, offset: 0 }"
          [nzMd]="{ span: 24, offset: 0 }"
          [nzSm]="{ span: 24, offset: 0 }"
          [nzXs]="{ span: 24, offset: 0 }">
          <textarea
            nz-input
            placeholder="Scrivi come sta andando!"
            [disabled]="!isLoggedUser && !userReveal && !reviewerReveal"
            [readOnly]="!isLoggedUser"
            [ngClass]="{
              'no-select my-mb-2': !isLoggedUser,
              'my-mb-2': isLoggedUser || userReveal
            }"
            [(ngModel)]="howIsGoing"
            [nzAutosize]="{ minRows: 7, maxRows: 7 }"
            (ngModelChange)="changeHowIsGoing($event)"></textarea>
          <div class="d-flex justify-content-end mt-3 mb-3">
            <button
              *ngIf="isLoggedUser && !userReveal"
              nz-button
              [ngClass]="
                isValidHowIsGoing
                  ? 'disabled-btn'
                  : 'secondary-btn cursor-pointer'
              "
              [disabled]="isValidHowIsGoing"
              (click)="saveHowIsGoing()">
              Salva
            </button>
          </div>
        </nz-col>
      </nz-row>
    </nz-col>

    <nz-col
      [nzLg]="{ span: 12, offset: 0 }"
      [nzMd]="{ span: 24, offset: 0 }"
      [nzSm]="{ span: 24, offset: 0 }"
      [nzXs]="{ span: 24, offset: 0 }">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h4 class="primary-color mb-0">Cosa pensiamo di te?</h4>

        <ng-container *ngIf="!isEdit">
          <button
            *ngIf="!isLoggedUser && !reviewerReveal"
            (click)="setReveal()"
            [disabled]="!existThoughtsAboutYou"
            nz-button
            [ngClass]="
              !existThoughtsAboutYou
                ? 'disabled-btn'
                : 'primary-btn cursor-pointer'
            ">
            Rivela
          </button>
          <div class="reveal-badge" *ngIf="!isLoggedUser && reviewerReveal">
            <p class="mb-0">Rivelato</p>
          </div>
        </ng-container>
      </div>

      <nz-row
        *ngIf="!isEdit"
        class="tiny-card px-2"
        [ngClass]="
          !isLoggedUser || (userReveal && reviewerReveal) ? '' : 'blurred'
        ">
        <nz-col
          [nzLg]="{ span: 24, offset: 0 }"
          [nzMd]="{ span: 24, offset: 0 }"
          [nzSm]="{ span: 24, offset: 0 }"
          [nzXs]="{ span: 24, offset: 0 }">
          <textarea
            nz-input
            [disabled]="isLoggedUser && !(userReveal && reviewerReveal)"
            [readOnly]="isLoggedUser"
            [ngClass]="{
              'no-select my-mb-2': isLoggedUser,
              'my-mb-2': !(isLoggedUser && !reviewerReveal)
            }"
            placeholder="Cosa pensiamo di te"
            [(ngModel)]="thoughtsAboutYou"
            [nzAutosize]="{ minRows: 7, maxRows: 7 }"
            (ngModelChange)="changeThoughtsAboutYou($event)"></textarea>
          <div class="d-flex justify-content-end mt-3 mb-3">
            <button
              *ngIf="!isLoggedUser && !reviewerReveal"
              nz-button
              [ngClass]="
                isValidThoughtsAboutYou
                  ? 'disabled-btn'
                  : 'secondary-btn cursor-pointer'
              "
              [disabled]="isValidThoughtsAboutYou"
              (click)="saveThoughtsAboutYou()">
              Salva
            </button>
          </div>
        </nz-col>
      </nz-row>
    </nz-col>
  </nz-row>
</div>
